(function () {
  const catalog = window.CATALOG;
  if (!catalog) return;

  const AUTOPLAY_MS = 4200;

  const $ = (selector, root = document) => root.querySelector(selector);
  const $$ = (selector, root = document) => Array.from(root.querySelectorAll(selector));
  const escapeHtml = window.PRODUCT_UTILS && window.PRODUCT_UTILS.escapeHtml
    ? window.PRODUCT_UTILS.escapeHtml
    : (value) => String(value);
  const productUrl = window.PRODUCT_UTILS && window.PRODUCT_UTILS.productUrl
    ? window.PRODUCT_UTILS.productUrl
    : (product) => `/pages/21ph-product-detail?series=${encodeURIComponent(product.seriesId)}&product=${encodeURIComponent(product.slug)}`;

  const caseUrl = (caseId, product) => `/pages/21ph-case-detail?case=${encodeURIComponent(caseId)}&product=${encodeURIComponent(product.slug)}`;

  function titleCase(value) {
    return String(value).replace(/\b[a-z]/g, (char) => char.toUpperCase());
  }

  function normalizeTag(value) {
    return String(value || '').trim().replace(/\s+/g, ' ');
  }

  function setMeta(selector, content) {
    if (!content) return;
    let node = document.head.querySelector(selector);
    if (!node) {
      node = document.createElement('meta');
      const match = selector.match(/meta\[(name|property)="([^"]+)"\]/);
      if (match) node.setAttribute(match[1], match[2]);
      document.head.appendChild(node);
    }
    node.setAttribute('content', content);
  }

  function setCanonical(url) {
    let node = document.head.querySelector('link[rel="canonical"]');
    if (!node) {
      node = document.createElement('link');
      node.setAttribute('rel', 'canonical');
      document.head.appendChild(node);
    }
    node.setAttribute('href', url);
  }

  function setJsonLd(id, data) {
    let node = document.getElementById(id);
    if (!node) {
      node = document.createElement('script');
      node.type = 'application/ld+json';
      node.id = id;
      document.head.appendChild(node);
    }
    node.textContent = JSON.stringify(data);
  }

  function stripText(value, maxLength) {
    const text = String(value || '').replace(/\s+/g, ' ').trim();
    return text.length > maxLength ? `${text.slice(0, maxLength - 1).trim()}…` : text;
  }

  function absolutePublicUrl(value) {
    if (!value) return '';
    try {
      return new URL(value, '/products/').href;
    } catch (error) {
      return value;
    }
  }

  function publicProductUrl(product) {
    return `/products/${encodeURIComponent(product.slug)}`;
  }

  function updateProductSeo(product, collection, colorImages) {
    const title = `${product.name} Flexible Stone Wall Cladding | 21ParkHouse`;
    const description = stripText(`${product.name} from ${collection.name} is a 21ParkHouse Flexible Stone wall cladding texture for interior walls, facades, ceilings, hotels, retail spaces and renovation projects. ${product.short || product.applicationText || ''}`, 158);
    const url = publicProductUrl(product);
    const image = absolutePublicUrl(colorImages && colorImages[0] ? colorImages[0].src : product.image);
    document.title = title;
    setMeta('meta[name="description"]', description);
    setMeta('meta[property="og:title"]', title);
    setMeta('meta[property="og:description"]', description);
    setMeta('meta[property="og:type"]', 'product');
    setMeta('meta[property="og:url"]', url);
    setMeta('meta[property="og:image"]', image);
    setMeta('meta[name="twitter:title"]', title);
    setMeta('meta[name="twitter:description"]', description);
    setMeta('meta[name="twitter:image"]', image);
    setCanonical(url);

    const productSchema = {
      '@context': 'https://schema.org',
      '@type': 'Product',
      name: `${product.name} Flexible Stone`,
      brand: { '@type': 'Brand', name: '21ParkHouse' },
      category: 'Flexible Stone wall cladding',
      material: 'Mineral powder, clay and quartz sand based flexible stone',
      image: image ? [image] : undefined,
      description,
      url,
      additionalProperty: Array.isArray(product.specs) ? product.specs.map((row) => ({
        '@type': 'PropertyValue',
        name: row[0],
        value: row[1]
      })) : undefined
    };
    setJsonLd('product-seo-jsonld', productSchema);
    setJsonLd('product-breadcrumb-jsonld', {
      '@context': 'https://schema.org',
      '@type': 'BreadcrumbList',
      itemListElement: [
        { '@type': 'ListItem', position: 1, name: 'Home', item: '/' },
        { '@type': 'ListItem', position: 2, name: 'Products', item: '/pages/21ph-products' },
        { '@type': 'ListItem', position: 3, name: product.name, item: url }
      ]
    });
  }


  const PRODUCT_TAG_MAP = {
    'travertine': ['Refined', 'Porous', 'Classical', 'Warm', 'Stone-Like'],
    'rammed-earth-wall': ['Raw', 'Earthy', 'Layered', 'Matte', 'Architectural'],
    'tyros-line-stone': ['Linear', 'Contemporary', 'Layered', 'Subtle', 'Mineral'],
    'tours-line-stone': ['Striated', 'Minimal', 'Rhythmic', 'Fine-Grained', 'Calm'],
    'ripple-line-stone': ['Rippled', 'Flowing', 'Soft', 'Textured', 'Modern'],
    'north-america-line-stone': ['Rugged', 'Layered', 'Linear', 'Stone-Like', 'Monumental'],
    'morocco-stone': ['Exotic', 'Handcrafted', 'Sandy', 'Rustic', 'Warm'],
    'montblanc-stone': ['Alpine', 'Cool-Toned', 'Mineral', 'Refined', 'Quiet'],
    'hill-stone': ['Natural', 'Uneven', 'Rustic', 'Earthy', 'Textured'],
    'glacier-stone': ['Cool-Toned', 'Rugged', 'Heavy', 'Mineral', 'Dramatic'],
    'evian-stone': ['Soft', 'Clean', 'Misty', 'Minimal', 'Light-Toned'],
    'concrete-pouring-slab': ['Raw', 'Industrial', 'Matte', 'Minimal', 'Cast Texture'],
    'natural-wood': ['Warm', 'Organic', 'Linear', 'Wood-Like', 'Soft'],
    'bjork-linear-timber': ['Nordic', 'Linear', 'Pale Wood', 'Minimal', 'Refined'],
    'kesong-carbonized-wood': ['Carbonized', 'Deep-Toned', 'Wood-Like', 'Warm', 'Sophisticated'],
    'shadow-of-bamboo': ['Oriental', 'Woven', 'Soft Shadow', 'Refined', 'Organic'],
    'matsue-w-weaving': ['Woven', 'Japanese', 'Rhythmic', 'Soft', 'Decorative'],
    'spanish-sandstone': ['Sandy', 'Rustic', 'Matte', 'Sun-Washed', 'Natural'],
    'oasis-stone': ['Fresh', 'Organic', 'Warm', 'Textured', 'Resort-Like'],
    'ocean-travertine': ['Coastal', 'Porous', 'Cool-Toned', 'Refined', 'Breezy'],
    'wind-and-clond-stone': ['Flowing', 'Poetic', 'Soft', 'Cloud-Like', 'Expressive'],
    'moonstone-a': ['Moonlit', 'Smooth', 'Mineral', 'Elegant', 'Cool-Toned'],
    'moonstone-b': ['Subtle Sheen', 'Soft', 'Refined', 'Misty', 'Minimal'],
    'kapa-mushroom-stone-12857': ['Sculptural', 'Rough', 'Volcanic', 'Heavy', 'Rustic'],
    'anner-mushroom-stone': ['Chunky', 'Organic', 'Rough', 'Stone-Like', 'Natural'],
    'berlin-line-stone': ['Urban', 'Linear', 'Sharp', 'Contemporary', 'Structured'],
    'sicily-ilne-stone': ['Mediterranean', 'Linear', 'Warm', 'Refined', 'Architectural'],
    'venation-stone': ['Veined', 'Elegant', 'Stone-Like', 'Layered', 'Refined'],
    'new-line-stone': ['Clean-Lined', 'Modern', 'Graphic', 'Minimal', 'Structured'],
    'carved-bamboo-stone': ['Sculptural', 'Bamboo-Like', 'Textured', 'Organic', 'Crafted'],
    'titanium-square': ['Metallic', 'Geometric', 'Sharp', 'Contemporary', 'Premium'],
    'wood-lattice-stone': ['Lattice', 'Woven', 'Structured', 'Decorative', 'Warm'],
    'sawm-timber': ['Sawn Grain', 'Rustic', 'Wood-Like', 'Warm', 'Raw'],
    'a-brick': ['Classic Brick', 'Rustic', 'Structured', 'Urban', 'Warm'],
    'k-brick': ['Kiln-Fired', 'Chunky', 'Rustic', 'Heavy', 'Architectural'],
    'r-brick': ['Red Clay', 'Vintage', 'Structured', 'Warm', 'Textured'],
    'travertine-pro': ['Refined', 'Porous', 'Durable', 'Classical', 'Exterior-Ready'],
    'coral-travertine-pro': ['Coral-Toned', 'Porous', 'Warm', 'Durable', 'Resort-Like'],
    'polished-stone-pro': ['Polished', 'Smooth', 'Elegant', 'Durable', 'Premium'],
    'skyline-pro': ['Urban', 'Linear', 'Sleek', 'Durable', 'High-Rise'],
    'limestone-pro': ['Soft', 'Mineral', 'Clean', 'Durable', 'Minimal'],
    'sandstone-pro': ['Sandy', 'Matte', 'Rugged', 'Durable', 'Natural'],
    'cretan-travertine-pro': ['Mediterranean', 'Porous', 'Warm', 'Ancient', 'Durable']
  };

  function makeTextureTags(product) {
    const mapped = PRODUCT_TAG_MAP[product.slug];
    if (mapped && mapped.length) return mapped;

    const sourceText = `${product.name || ''} ${product.short || ''} ${product.story || ''} ${product.applicationText || ''}`.toLowerCase();
    const tags = [];

    const add = (...values) => {
      values.forEach((value) => {
        const clean = normalizeTag(value);
        if (!clean) return;
        if (!tags.some((item) => item.toLowerCase() === clean.toLowerCase())) tags.push(clean);
      });
    };

    const fallbackRules = [
      { tag: 'Refined', test: /(refined|elegan|luxur|boutique|premium|upscale|timeless|roman)/ },
      { tag: 'Minimal', test: /(minimal|minimalist|clean|simple|understated|plain|quiet)/ },
      { tag: 'Rustic', test: /(rustic|weathered|aged|ancient|heritage|old-world)/ },
      { tag: 'Stone-Like', test: /(authentic|natural|realistic|replicate|mirror|stone-like|organic beauty|true-to-stone)/ },
      { tag: 'Textured', test: /(tactile|textur|dimensional|relief|grain|pattern|surface character)/ },
      { tag: 'Porous', test: /(porous|pitting|pits|travertine|mineral deposits)/ },
      { tag: 'Warm', test: /(warm|earthy hue|beige|taupe|honey|wood tone|soft tone)/ },
      { tag: 'Layered', test: /(layer|strata|mineral-rich|banded|depth)/ },
      { tag: 'Linear', test: /(line stone|linear|slat|slatted|striped|groove)/ },
      { tag: 'Woven', test: /(weaving|woven|weave|lattice|rattan|bamboo|mat)/ },
      { tag: 'Matte', test: /(matte|sandstone|chalky)/ },
      { tag: 'Sculptural', test: /(mushroom|carved|sculptural|bold relief)/ },
      { tag: 'Contemporary', test: /(modern|contemporary|minimalist)/ }
    ];

    fallbackRules.forEach((rule) => {
      if (rule.test.test(sourceText)) add(rule.tag);
    });

    if (tags.length < 4) add('Mineral', 'Architectural', 'Flexible');
    return tags.slice(0, 5).map(titleCase);
  }

  function getCaseForProduct(product, colorImages) {
    const caseMap = window.PRODUCT_CASES || {};
    const cases = window.CASES || {};
    const caseId = caseMap[product.slug];
    const matched = caseId && cases[caseId];
    if (matched) return { ...matched, isPlaceholder: false };
    return {
      id: `placeholder-${product.slug}`,
      title: `${product.name} Case Entry`,
      category: 'Case to be added',
      location: 'To be confirmed',
      year: '',
      materials: product.name,
      application: product.applicationText || 'Application information to be confirmed.',
      summary: `A dedicated project case for ${product.name} has not been added yet. This entry is reserved for future project photos and project information.`,
      detail: `This blank case page is prepared as the future project entry for ${product.name}. Add project location, product use, installation area and finished photos here once a matching real project is confirmed.`,
      sourceUrl: '',
      isPlaceholder: true,
      image: colorImages && colorImages[0] ? colorImages[0].src : product.image
    };
  }

  function findActiveProduct() {
    const params = new URLSearchParams(window.location.search);
    const slug = params.get('product');
    const requestedSeries = params.get('series');
    return catalog.products.find((item) => item.slug === slug && (!requestedSeries || item.seriesId === requestedSeries)) ||
      catalog.products.find((item) => item.slug === slug) ||
      catalog.products.find((item) => item.seriesId === requestedSeries) ||
      catalog.products[0];
  }

  function buildCarousel(visualRoot, switcherRoot, colorImages, product) {
    const existingImage = $('[data-product-image]', visualRoot);
    if (!visualRoot || !existingImage || !colorImages.length) return;

    const slidesMarkup = colorImages.map((item, index) => `
      <div class="detail-carousel-slide" data-slide-index="${index}" aria-hidden="${index === 0 ? 'false' : 'true'}">
        <img src="${item.src}" alt="${escapeHtml(item.alt || product.name)} detail image ${index + 1}" loading="${index === 0 ? 'eager' : 'lazy'}">
      </div>
    `).join('');

    existingImage.insertAdjacentHTML('beforebegin', `
      <div class="detail-carousel ${colorImages.length > 1 ? 'has-multiple' : ''}" data-detail-carousel>
        <div class="detail-carousel-track" data-detail-carousel-track>
          ${slidesMarkup}
        </div>
        ${colorImages.length > 1 ? `
          <button class="detail-carousel-nav is-prev" type="button" data-carousel-prev aria-label="Previous detail image">‹</button>
          <button class="detail-carousel-nav is-next" type="button" data-carousel-next aria-label="Next detail image">›</button>
        ` : ''}
      </div>
    `);
    existingImage.remove();

    const carousel = $('[data-detail-carousel]', visualRoot);
    const track = $('[data-detail-carousel-track]', visualRoot);
    const slides = $$('.detail-carousel-slide', visualRoot);
    if (!carousel || !track || !slides.length) return;

    let activeIndex = 0;
    let autoplayTimer = null;

    const swatches = switcherRoot
      ? colorImages.map((item, index) => `
        <button class="color-swatch${index === 0 ? ' is-active' : ''}" type="button" data-swatch-index="${index}" aria-label="${escapeHtml(product.name)} detail ${index + 1}" aria-pressed="${index === 0 ? 'true' : 'false'}">
          <img src="${item.src}" alt="${escapeHtml(item.alt || product.name)} thumbnail ${index + 1}">
        </button>
      `).join('')
      : '';

    if (switcherRoot) {
      if (colorImages.length > 1) {
        switcherRoot.hidden = false;
        switcherRoot.innerHTML = swatches;
      } else {
        switcherRoot.hidden = true;
        switcherRoot.innerHTML = '';
      }
    }

    const swatchButtons = switcherRoot ? $$('.color-swatch', switcherRoot) : [];

    function setActiveSlide(nextIndex, options = {}) {
      const length = slides.length;
      if (!length) return;
      activeIndex = (nextIndex + length) % length;

      if (options.immediate) {
        track.style.transition = 'none';
      } else {
        track.style.transition = '';
      }
      track.style.transform = `translateX(-${activeIndex * 100}%)`;
      if (options.immediate) {
        requestAnimationFrame(() => {
          track.style.transition = '';
        });
      }

      slides.forEach((slide, index) => {
        slide.setAttribute('aria-hidden', index === activeIndex ? 'false' : 'true');
      });

      swatchButtons.forEach((button, index) => {
        button.classList.toggle('is-active', index === activeIndex);
        button.setAttribute('aria-pressed', index === activeIndex ? 'true' : 'false');
      });
    }

    function stopAutoplay() {
      if (autoplayTimer) {
        window.clearInterval(autoplayTimer);
        autoplayTimer = null;
      }
    }

    function startAutoplay() {
      stopAutoplay();
      if (slides.length <= 1) return;
      autoplayTimer = window.setInterval(() => {
        setActiveSlide(activeIndex + 1);
      }, AUTOPLAY_MS);
    }

    const prevButton = $('[data-carousel-prev]', visualRoot);
    const nextButton = $('[data-carousel-next]', visualRoot);

    if (prevButton) prevButton.addEventListener('click', () => {
      setActiveSlide(activeIndex - 1);
      startAutoplay();
    });
    if (nextButton) nextButton.addEventListener('click', () => {
      setActiveSlide(activeIndex + 1);
      startAutoplay();
    });

    swatchButtons.forEach((button, index) => {
      button.addEventListener('click', () => {
        setActiveSlide(index);
        startAutoplay();
      });
    });

    carousel.addEventListener('mouseenter', stopAutoplay);
    carousel.addEventListener('mouseleave', startAutoplay);
    carousel.addEventListener('focusin', stopAutoplay);
    carousel.addEventListener('focusout', startAutoplay);

    setActiveSlide(0, { immediate: true });
    startAutoplay();
  }

  function renderDetail() {
    const root = $('[data-product-name]');
    if (!root) return;
    const product = findActiveProduct();
    const collection = catalog.series.find((item) => item.id === product.seriesId);
    const backUrl = `/pages/21ph-products?series=${encodeURIComponent(product.seriesId)}#collection`;

    $('[data-product-name]').textContent = product.name;
    $('[data-product-series]').textContent = collection.name;
    $('[data-product-short]').textContent = product.short;
    $('[data-product-story]').textContent = product.story;
    const applicationText = $('[data-product-application]');
    if (applicationText) applicationText.textContent = product.applicationText || '';

    const visual = $('[data-detail-visual]');
    if (visual) {
      visual.style.setProperty('--series-accent', product.accent);
    }

    const colorImages = (product.colorImages && product.colorImages.length)
      ? product.colorImages
      : (product.sourceImages && product.sourceImages.length)
        ? [product.sourceImages[0]]
        : [{ src: product.image, alt: product.name }];

    updateProductSeo(product, collection, colorImages);

    const switcherRoot = $('[data-color-switcher]');
    if (visual) {
      buildCarousel(visual, switcherRoot, colorImages, product);
    }

    document.documentElement.style.setProperty('--series-accent', product.accent);

    document.querySelectorAll('[data-product-back]').forEach((link) => {
      link.href = backUrl;
    });

    const chipRoot = $('[data-product-chips]');
    if (chipRoot) {
      const textureTags = makeTextureTags(product);
      chipRoot.innerHTML = textureTags.map((chip) => `<span class="character-chip">${escapeHtml(chip)}</span>`).join('');
    }

    const specRoot = $('[data-spec-panel]');
    if (specRoot) {
      specRoot.innerHTML = product.specs.map((row) => `<div class="spec-row"><strong>${escapeHtml(row[0])}</strong><span>${escapeHtml(row[1])}</span></div>`).join('');
    }

    const caseGrid = $('[data-case-grid]');
    if (caseGrid) {
      const selectedCase = getCaseForProduct(product, colorImages);
      const caseImage = selectedCase.image || (colorImages[0] && colorImages[0].src) || product.image;
      const productLine = selectedCase.isPlaceholder
        ? `Product: ${product.name}`
        : `Project uses: ${selectedCase.materials}`;
      caseGrid.innerHTML = `
        <a class="case-entry-card${selectedCase.isPlaceholder ? ' is-empty-case' : ''}" href="${caseUrl(selectedCase.id, product)}">
          <div class="case-entry-image"><img src="${caseImage}" alt="${escapeHtml(selectedCase.title)}" loading="lazy"></div>
          <div class="case-entry-copy">
            <span class="case-entry-kicker">${escapeHtml(selectedCase.category || 'Case')}</span>
            <h3>${escapeHtml(selectedCase.title)}</h3>
            <p>${escapeHtml(selectedCase.summary)}</p>
            <dl>
              <div><dt>Application</dt><dd>${escapeHtml(selectedCase.application || 'To be confirmed')}</dd></div>
              <div><dt>Material</dt><dd>${escapeHtml(productLine)}</dd></div>
            </dl>
            <span class="case-entry-link">View case <i>→</i></span>
          </div>
        </a>
      `;
    }

    const relatedRoot = $('[data-related-grid]');
    if (relatedRoot) {
      const related = catalog.products.filter((item) => item.seriesId === product.seriesId && item.slug !== product.slug).slice(0, 4);
      relatedRoot.innerHTML = related.map((item) => `
        <a class="related-card" href="${productUrl(item)}"><img src="${item.image}" alt="${escapeHtml(item.name)} texture"><span>${escapeHtml(item.name)}</span></a>
      `).join('');
    }
  }

  document.addEventListener('DOMContentLoaded', renderDetail);
})();
